import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { useTranslation } from "react-i18next";

const CompanyDetailContact = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput fieldName={"actualAddress"} title={t("ActualAddress")} />
        </Col>
        <Col sm={6}>
          <NFTextInput fieldName={"legalAddress"} title={t("LegalAddress")} />
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
          <NFTextInput fieldName={"email"} title={t("Email")} />
        </Col>
        <Col sm={6}>
          <NFTextInput fieldName={"phoneNumber"} title={t("Phone")} />
        </Col>
      </Row>
    </>
  );
};

export default CompanyDetailContact;
